<template>
      <payment-print
      :selectedPatient="patient"
      :selectedPayment="payment"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      />
</template>

<script>

import PaymentPrint from '../../components/Print/PaymentPrint.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'PaymentPrintIndex',
  components: {
    PaymentPrint,
  },
  data() {
    return {
      convertToVirtualCurrency: false,
      useBillingGroupTemplate: false,
    };
  },
  computed: {
    ...mapGetters('payment',['selectedPayment']),
    ...mapGetters('patient', ['selectedPatient']),
    ...mapGetters('invoice', ['print']),
    ...mapGetters('config', {
      generalConfig: 'general',
      invoiceConfig: 'invoice',
      patientConfig: 'patient',
      featureFlags: 'featureFlags',
      virtualCurrencyConfig: 'virtualCurrency',
    }),
    patient() {
      return this.$store.state.patient.selectedPatient;
    },
    payment() {
      return this.$store.state.payment.selectedPayment;
    },
    roundingMethod() {
      let roundingMethod;
      if (typeof this.print.roundingEnabled === 'undefined') {
        roundingMethod = this.invoiceConfig.roundOff;
      } else {
        roundingMethod = this.print.roundingEnabled ? 'ROUND0P05' : 'NONE';
      }
      return roundingMethod;
    },
    redeem() {
      return this.print.items.filter(i => i.redeemedPoint > 0)
        .reduce((a, b) => {
          a.point += b.redeemedPoint; 
          a.amount += b.redeemAmountAfterTax; 
          return a;
        }, { point: 0, amount: 0 });
    },
  
  },
  created() {
    if (this.$route.query && this.$route.query['virtual-currency']) {
      this.convertToVirtualCurrency = true;
    }

    if (this.$route.query && this.$route.query.billingGroup) {
      this.useBillingGroupTemplate = true;
    }
  },
};
</script>
